import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSocialGitHubSvg } from "./IconSocialGitHubSvg.mjs";
const IconSocialGitHub = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSocialGitHubSvg, ...svgProps }) });
export {
  IconSocialGitHub
};
